export default "__VITE_ASSET__CsLktfF9__"